import React,{useState,useEffect,useCallback}from'react';
import Layout from'../components/layout/Layout';
import Modal from'../components/common/Modal';
import Badge from'../components/common/Badge';
import StatCard from'../components/common/StatCard';
import api from'../services/api';
import PatientSearchInput from '../components/patient/PatientSearchInput';

const SEVERITY_COLOR:any={CRITICAL:'red',SERIOUS:'orange',MODERATE:'yellow',STABLE:'green'};

export default function ICUPage(){
  const [admissions,setAdmissions]=useState<any[]>([]);
  const [selected,setSelected]=useState<any>(null);
  const [monitoring,setMonitoring]=useState<any[]>([]);
  const [loading,setLoading]=useState(false);
  const [tab,setTab]=useState('admissions');
  const [msg,setMsg]=useState('');
  const [showVitals,setShowVitals]=useState(false);
  const [showAdmit,setShowAdmit]=useState(false);
  const [vitalsForm,setVitalsForm]=useState({heartRate:'',systolic:'',diastolic:'',spo2:'',temperature:'',respiratoryRate:'',cvp:'',mapValue:'',urine_output:'',gcs:''});
  const [admitForm,setAdmitForm]=useState({patientId:'',bedId:'',diagnosis:'',ventilatorRequired:false,sedationProtocol:'',targetMAP:'65'});
  const [stats,setStats]=useState({total:0,ventilated:0,critical:0,available:0});
  const load=async()=>{
    setLoading(true);
    try{
      const[adm,st]=await Promise.all([
        api.getICUAdmissions({take:50}).catch(()=>({data:[]})),
        api.getICUStats?.().catch(()=>({data:{}})),
      ]);
      setAdmissions(Array.isArray(adm.data)?adm.data:adm.data?.admissions||adm.data?.data||[]);
      setStats(st.data||{});
    }catch{}
    setLoading(false);
  };
  useEffect(()=>{load();},[]);

  const loadMonitoring=async(adm:any)=>{
    setSelected(adm);
    try{
      const r=await api.getICUMonitoring(adm.id);
      setMonitoring(Array.isArray(r.data)?r.data:r.data?.monitoring||r.data?.data||[]);
    }catch{setMonitoring([]);}
  };

  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),4000);};

  // const load=useCallback(async()=>{
  //   setLoading(true);
  //   try{
  //     const r=await api.getIcuAdmissions?.().catch(()=>({data:[]}));
  //     const adm=Array.isArray(r?.data)?r.data:r?.data?.data||r?.data?.admissions||[];
  //     setAdmissions(adm);
  //     setStats({total:adm.length,ventilated:adm.filter((a:any)=>a.ventilator_required||a.ventilatorRequired).length,critical:adm.filter((a:any)=>a.acuity_score>=8).length,available:0});
  //   }catch{}
  //   setLoading(false);
  // },[]);

  // const loadMonitoring=async(adm:any)=>{
  //   setSelected(adm);
  //   try{
  //     const r=await api.getIcuMonitoring?.(adm.id).catch(()=>({data:[]}));
  //     setMonitoring(Array.isArray(r?.data)?r.data:r?.data?.data||[]);
  //   }catch{}
  // };

  const saveVitals=async()=>{
    if(!selected)return;
    try{
      await api.addIcuMonitoring?.(selected.id,{...vitalsForm,heartRate:+vitalsForm.heartRate,systolic:+vitalsForm.systolic,diastolic:+vitalsForm.diastolic,spo2:+vitalsForm.spo2,temperature:+vitalsForm.temperature,respiratoryRate:+vitalsForm.respiratoryRate});
      notify('Vitals saved');setShowVitals(false);await loadMonitoring(selected);
    }catch(e:any){notify('Error: '+(e.response?.data?.message||'failed'));}
  };

  const admitICU=async()=>{
    if(!admitForm.patientId)return;
    try{await api.createIcuAdmission?.(admitForm);notify('ICU admission created');setShowAdmit(false);await load();}
    catch(e:any){notify('Error: '+(e.response?.data?.message||'failed'));}
  };

  useEffect(()=>{load();},[load]);

  const getTrend=(vals:number[])=>{if(vals.length<2)return'→';return vals[vals.length-1]>vals[0]?'↑':vals[vals.length-1]<vals[0]?'↓':'→';};

  return(
    <Layout title="ICU Management" actions={
      <button onClick={()=>setShowAdmit(true)} className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2.5 px-5 rounded-xl text-sm">+ ICU Admission</button>
    }>
      {msg&&<div className="fixed top-5 right-5 z-[99999] px-5 py-3 rounded-2xl shadow-xl text-sm font-semibold bg-green-50 text-green-800 border border-green-200">{msg}</div>}

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4 mb-5">
        {[['ICU Census',stats.total,'from-blue-600 to-blue-700'],['On Ventilator',stats.ventilated,'from-red-600 to-red-700'],['Critical (APACHE≥8)',stats.critical,'from-orange-500 to-orange-600'],['Available Beds',stats.available,'from-emerald-600 to-teal-600']].map(([l,v,g])=>(
          <div key={String(l)} className={`bg-gradient-to-br ${g} text-white rounded-2xl p-4 shadow-md`}>
            <p className="text-xs font-semibold opacity-80 uppercase tracking-wide">{l}</p>
            <p className="text-3xl font-black mt-1">{v}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-5 gap-5">
        {/* Patient List */}
        <div className="col-span-2 bg-white rounded-2xl border border-red-200 shadow-sm overflow-hidden">
          <div className="px-4 py-3 border-b bg-red-50 flex items-center justify-between">
            <h3 className="font-bold text-red-700">ICU Patients ({admissions.length})</h3>
            {loading&&<span className="text-xs text-slate-400 animate-pulse">Loading…</span>}
          </div>
          <div className="divide-y overflow-y-auto" style={{maxHeight:'72vh'}}>
            {admissions.length===0?(
              <div className="p-8 text-center text-slate-400">No ICU admissions</div>
            ):admissions.map((a:any)=>(
              <div key={a.id} onClick={()=>loadMonitoring(a)}
                className={`p-4 cursor-pointer hover:bg-red-50 transition-colors ${selected?.id===a.id?'bg-red-50 border-l-4 border-red-500':''}`}>
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1">
                    <p className="font-semibold text-slate-800">{a.patient_name||a.patientName||`${a.first_name||''} ${a.last_name||''}`.trim()||'Patient'}</p>
                    <p className="text-xs text-slate-500 font-mono mt-0.5">{a.uhid||a.patient?.uhid||'—'} · Bed {a.bed_number||a.bedNumber||a.icu_bed||'—'}</p>
                    <p className="text-xs text-slate-600 mt-1 truncate">{a.primary_diagnosis||a.diagnosis||'—'}</p>
                    <div className="flex gap-1.5 mt-1.5 flex-wrap">
                      {(a.ventilator_required||a.ventilatorRequired)&&<span className="text-xs font-bold px-2 py-0.5 rounded-full bg-red-100 text-red-700">VENT</span>}
                      <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-[#02357A]">Day {a.icu_day||1}</span>
                    </div>
                  </div>
                  <div className="flex-shrink-0 text-right">
                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${a.severity==='CRITICAL'?'bg-red-100 text-red-700':a.severity==='SERIOUS'?'bg-orange-100 text-orange-700':'bg-yellow-100 text-yellow-700'}`}>
                      {a.acuity||a.severity||'SERIOUS'}
                    </span>
                    {a.acuity_score&&<p className="text-xs text-slate-400 mt-1">APACHE: {a.acuity_score}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Detail Panel */}
        <div className="col-span-3 bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
          {!selected?(
            <div className="flex items-center justify-center h-96 text-slate-400">
              <div className="text-center"><p className="text-5xl mb-3">🏥</p><p>Select a patient to view monitoring data</p></div>
            </div>
          ):(
            <>
              <div className="px-5 py-4 border-b bg-gradient-to-r from-red-50 to-orange-50">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-lg font-bold text-slate-800">{selected.patient_name||selected.patientName||'Patient'}</h2>
                    <p className="text-sm text-slate-500 mt-0.5">Bed {selected.bed_number||selected.icu_bed||'—'} · {selected.primary_diagnosis||'—'}</p>
                  </div>
                  <button onClick={()=>setShowVitals(true)} className="bg-red-600 hover:bg-red-700 text-white font-semibold px-4 py-2 rounded-xl text-sm">+ Vitals</button>
                </div>
                <div className="flex gap-2 mt-3">
                  {[['monitor','Monitoring'],['orders','Orders'],['notes','Notes']].map(([k,l])=>(
                    <button key={k} onClick={()=>setTab(k)} className={`px-4 py-1.5 rounded-xl text-xs font-semibold border-2 transition-all ${tab===k?'bg-red-600 text-white border-red-600':'border-slate-200 text-slate-600 hover:border-red-300'}`}>{l}</button>
                  ))}
                </div>
              </div>

              <div className="p-4 overflow-y-auto" style={{maxHeight:'calc(72vh - 140px)'}}>
                {tab==='monitor'&&(
                  <>
                    {monitoring.length>0&&(()=>{
                      const latest=monitoring[monitoring.length-1];
                      const vitals=[
                        {l:'Heart Rate',v:`${latest.heart_rate||latest.heartRate||'—'} bpm`,red:((latest.heart_rate||latest.heartRate)||0)>100},
                        {l:'BP',v:`${latest.systolic||'—'}/${latest.diastolic||'—'} mmHg`,red:false},
                        {l:'SpO2',v:`${latest.spo2||latest.oxygen_saturation||'—'}%`,red:((latest.spo2||latest.oxygen_saturation)||100)<94},
                        {l:'Temperature',v:`${latest.temperature||'—'}°F`,red:false},
                        {l:'RR',v:`${latest.respiratory_rate||latest.respiratoryRate||'—'}/min`,red:false},
                        {l:'GCS',v:`${latest.gcs_total||latest.gcs||'—'}/15`,red:((latest.gcs_total||latest.gcs)||15)<8},
                        {l:'Urine Output',v:`${latest.urine_output||'—'} mL/hr`,red:false},
                        {l:'MAP',v:`${latest.map_value||latest.mapValue||'—'} mmHg`,red:false},
                      ];
                      return(
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
                          {vitals.map(({l,v,red})=>(
                            <div key={l} className={`p-3 rounded-xl border-2 ${red?'bg-red-50 border-red-200':'bg-slate-50 border-slate-200'}`}>
                              <p className="text-xs text-slate-500">{l}</p>
                              <p className={`text-xl font-black mt-0.5 ${red?'text-red-700':'text-slate-800'}`}>{v}</p>
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                    <h4 className="font-semibold text-slate-700 mb-3 text-sm">Monitoring History ({monitoring.length} records)</h4>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead className="bg-slate-50"><tr>{['Time','HR','BP','SpO2','Temp','RR','GCS','Urine'].map(h=><th key={h} className="text-left px-3 py-2 text-xs text-slate-500 font-bold">{h}</th>)}</tr></thead>
                        <tbody className="divide-y divide-slate-100">
                          {monitoring.slice().reverse().map((m:any,i)=>(
                            <tr key={i} className="hover:bg-slate-50">
                              <td className="px-3 py-2 text-xs text-slate-400">{m.recorded_at?.split('T')[1]?.substring(0,5)||'—'}</td>
                              <td className={`px-3 py-2 font-medium ${(m.heart_rate||0)>100?'text-red-600':''}`}>{m.heart_rate||'—'}</td>
                              <td className="px-3 py-2">{m.systolic&&m.diastolic?`${m.systolic}/${m.diastolic}`:'—'}</td>
                              <td className={`px-3 py-2 font-medium ${(m.spo2||100)<94?'text-red-600':''}`}>{m.spo2||'—'}%</td>
                              <td className="px-3 py-2">{m.temperature||'—'}</td>
                              <td className="px-3 py-2">{m.respiratory_rate||'—'}</td>
                              <td className={`px-3 py-2 font-medium ${(m.gcs_total||15)<8?'text-red-600':''}`}>{m.gcs_total||'—'}</td>
                              <td className="px-3 py-2">{m.urine_output||'—'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                {tab==='orders'&&<div className="text-center text-slate-400 py-12 text-sm">Doctor orders for this ICU patient — link to CPOE</div>}
                {tab==='notes'&&<div className="text-center text-slate-400 py-12 text-sm">ICU nursing and doctor notes</div>}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Vitals Modal */}
      <Modal isOpen={showVitals} onClose={()=>setShowVitals(false)} title="Record ICU Vitals">
        <div className="grid grid-cols-2 gap-4">
          {[['Heart Rate (bpm)','heartRate'],['Systolic BP','systolic'],['Diastolic BP','diastolic'],['SpO2 (%)','spo2'],['Temperature (°F)','temperature'],['Respiratory Rate','respiratoryRate'],['CVP (mmHg)','cvp'],['MAP (mmHg)','mapValue'],['Urine Output (mL/hr)','urine_output'],['GCS Total','gcs']].map(([l,k])=>(
            <div key={k}>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5">{l}</label>
              <input type="number" value={(vitalsForm as any)[k]} onChange={e=>setVitalsForm(f=>({...f,[k]:e.target.value}))}
                className="w-full bg-white border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none focus:border-[#02357A]"/>
            </div>
          ))}
        </div>
        <div className="flex gap-3 mt-5">
          <button onClick={()=>setShowVitals(false)} className="bg-white hover:bg-slate-50 text-slate-700 font-semibold py-2.5 px-5 rounded-xl border-2 border-slate-200 text-sm flex-1">Cancel</button>
          <button onClick={saveVitals} className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2.5 px-5 rounded-xl text-sm flex-1">Save Vitals</button>
        </div>
      </Modal>

      {/* Admit Modal */}
      <Modal isOpen={showAdmit} onClose={()=>setShowAdmit(false)} title="New ICU Admission">
        <div className="space-y-4">
          {[['Patient ID *','patientId','Patient UHID or ID'],['ICU Bed','bedId','Bed ID'],['Primary Diagnosis','diagnosis','Diagnosis']].map(([l,k,ph])=>(
            <div key={k}>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5">{l}</label>
              <input value={(admitForm as any)[k]} onChange={e=>setAdmitForm(f=>({...f,[k]:e.target.value}))} placeholder={ph}
                className="w-full bg-white border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none focus:border-[#02357A]"/>
            </div>
          ))}
          <label className="flex items-center gap-3 cursor-pointer p-3 rounded-xl border-2 border-slate-200 hover:border-red-300 transition-all">
            <input type="checkbox" checked={admitForm.ventilatorRequired} onChange={e=>setAdmitForm(f=>({...f,ventilatorRequired:e.target.checked}))} className="w-4 h-4 accent-red-600"/>
            <span className="text-sm font-medium text-slate-700">Ventilator Required</span>
          </label>
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5">Target MAP (mmHg)</label>
            <input value={admitForm.targetMAP} onChange={e=>setAdmitForm(f=>({...f,targetMAP:e.target.value}))}
              className="w-full bg-white border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none focus:border-[#02357A]"/>
          </div>
          <div className="flex gap-3 pt-2">
            <button onClick={()=>setShowAdmit(false)} className="bg-white hover:bg-slate-50 text-slate-700 font-semibold py-2.5 px-5 rounded-xl border-2 border-slate-200 text-sm flex-1">Cancel</button>
            <button onClick={admitICU} className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2.5 px-5 rounded-xl text-sm flex-1">Admit to ICU</button>
          </div>
        </div>
      </Modal>
    </Layout>
  );
}
